<template>
  <van-sticky>
    <div class="tLobbyParentDiv" :style="{
      backgroundColor:HNewGameUIConfig.newGameUIType === 3?'#000':'#fff',
      backgroundImage:HNewGameUIConfig.newGameUIType === 0 || HNewGameUIConfig.newGameUIType === 4?'':`url(${iconTopHeaderBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
      padding:HNewGameUIConfig.newGameUIType === 0 || HNewGameUIConfig.newGameUIType === 4?'10px 15px':'15px 15px',
    }">
      <van-icon @click="hr.goBack()" name="arrow-left" size="21" :color="HNewGameUIConfig.newGameUIType === 3?'white':'black'"/>
      <div style="display: flex;margin-left: 30px;">
        <HShowRefreshBalance :moneyColor="HNewGameUIConfig.newGameUIType === 3?'white':'#333'"/>
<!--        <div @click="hr.go('search')"-->
<!--             style="background-color: #eee;border-radius: 30px;padding:4px 10px;margin-left: 18px;display: flex;flex-direction: row;align-items: center;">-->
<!--          <div :style="hcf.getTextStyle({-->
<!--          color:'#999',marginRight:50,addSize:-1-->
<!--        })">搜索游戏-->
<!--          </div>-->
<!--          <van-icon @click="hr.goBack()" name="search" size="17" color="#999"/>-->
<!--        </div>-->
<!--        <div style="width:100px;"/>-->
      </div>
    </div>
  </van-sticky>
  <van-tabs sticky v-if="datas!==null" v-model:active="activeName"
            :title-active-color="hcf.getMainColor()">
    <van-tab v-for="eachTabInfo in datas['AllInnerNav']" :title="eachTabInfo['Name']" :name="eachTabInfo['Name']"
             :key="eachTabInfo['Name']">
      <EachLobbyTab :curInnerNavId="eachTabInfo['Id']" :initChildNavId="initChildNavId"/>
    </van-tab>
  </van-tabs>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HShowRefreshBalance from "@/components/utils/HShowRefreshBalance.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import EachLobbyTab from "@/components/pages/Lobby/EachLobbyTab.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const iconTopHeaderBg = hcf.getNewGameUIIcon("vip_tequan_top_bg.jpg");


  const user = useUserStore();
  const http = useHHttp();
  const props = hr.getRouteParams();
  const datas = ref(null);
  let initInnerNavId = 0;
  let initChildNavId = 0;
  const activeName = ref("");
  if (props) {
    initInnerNavId = props["InnerNavId"];
    initChildNavId = props["ChildNavId"];
  }

  onMounted(() => {
    useHComApi().getSecondGameData((resp) => {
      datas.value = resp["Data"];
      activeName.value = datas.value["AllInnerNav"][0].Name;
      if(initInnerNavId!==0){
        for(let i = 0;i<datas.value["AllInnerNav"].length;i++){
          if(datas.value["AllInnerNav"][i].Id === initInnerNavId){
            activeName.value = datas.value["AllInnerNav"][i].Name;
            break;
          }
        }
      }
    }, {
      innerNavId: initInnerNavId, childNavId: initChildNavId
    });
  });

</script>


<style scoped>
  ::v-deep(.van-tab) {
    font-size: 15px;
  }
  ::v-deep(.van-tabs__line) {
    background-color: var(--ct-main-color); /* 改为你想要的颜色 */
  }
  .tLobbyParentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
</style>
